import { useState, useEffect } from "react";
import api from "../utils/apiConfig";

import logger from '../utils/logger';

export default function useHouseholdHoldings(householdId) {
  const [holdings, setHoldings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [assetAllocation, setAssetAllocation] = useState({});
  const [sectorAllocation, setSectorAllocation] = useState({});
  const [totalMarketValue, setTotalMarketValue] = useState(0);

  useEffect(() => {
    if (!householdId) return;
    let isMounted = true;
    setLoading(true);
    const url = `/advisor-portal/holdings?household_id=${householdId}`;
    logger.info("[useHouseholdHoldings] Fetching:", url);
    api
      .get(url)
      .then((res) => {
        if (!isMounted) return;
        const data = res.data || [];
        setHoldings(data);
        // Aggregate asset allocation and sector allocation
        const assetMap = {};
        const sectorMap = {};
        let total = 0;
        data.forEach((h) => {
          const asset = h.asset_class || "Unknown";
          const sector = h.sector || "Unknown";
          const mv = parseFloat(h.market_value) || 0;
          assetMap[asset] = (assetMap[asset] || 0) + mv;
          sectorMap[sector] = (sectorMap[sector] || 0) + mv;
          total += mv;
        });
        setAssetAllocation(assetMap);
        setSectorAllocation(sectorMap);
        setTotalMarketValue(total);
        setLoading(false);
      })
      .catch((err) => {
        if (isMounted) {
          logger.error(
            "[useHouseholdHoldings] API error for householdId",
            householdId,
            "URL:",
            url,
            err,
          );
          setError(
            (err.response && err.response.data && err.response.data.details) ||
              err.message ||
              "Failed to fetch household holdings",
          );
          setLoading(false);
        }
      });
    return () => {
      isMounted = false;
    };
  }, [householdId]);

  return {
    holdings,
    loading,
    error,
    assetAllocation,
    sectorAllocation,
    totalMarketValue,
  };
}
